import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "stemvet_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && typeof window !== "undefined") {
      clearToken();
      if (!window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

// Public
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const fetchBlogPosts = () => api.get("/blog").then((r) => r.data);
export const fetchBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);

// Admin auth
export const adminLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = () => api.get("/auth/me").then((r) => r.data);

// Admin blog CRUD
export const adminListPosts = () => api.get("/blog/admin/all").then((r) => r.data);
export const adminListCategories = () => api.get("/blog/admin/categories").then((r) => r.data);
export const adminGetPost = (id) => api.get(`/blog/admin/${id}`).then((r) => r.data);
export const adminCreatePost = (payload) => api.post("/blog", payload).then((r) => r.data);
export const adminUpdatePost = (id, payload) => api.put(`/blog/${id}`, payload).then((r) => r.data);
export const adminDeletePost = (id) => api.delete(`/blog/${id}`).then((r) => r.data);

// Public newsletter
export const subscribeNewsletter = (email) => api.post("/newsletter/subscribe", { email }).then((r) => r.data);

// Admin newsletter
export const adminListNewsletters = () => api.get("/admin/newsletter").then((r) => r.data);
export const adminGetNewsletter = (id) => api.get(`/admin/newsletter/${id}`).then((r) => r.data);
export const adminCreateNewsletter = (payload) => api.post("/admin/newsletter", payload).then((r) => r.data);
export const adminUpdateNewsletter = (id, payload) => api.put(`/admin/newsletter/${id}`, payload).then((r) => r.data);
export const adminDeleteNewsletter = (id) => api.delete(`/admin/newsletter/${id}`).then((r) => r.data);
export const adminSendTest = (id) => api.post(`/admin/newsletter/${id}/test`).then((r) => r.data);
export const adminSendNewsletter = (id) => api.post(`/admin/newsletter/${id}/send`).then((r) => r.data);
export const adminScheduleNewsletter = (id, scheduled_at) =>
  api.post(`/admin/newsletter/${id}/schedule`, { scheduled_at }).then((r) => r.data);
export const adminUnscheduleNewsletter = (id) =>
  api.post(`/admin/newsletter/${id}/unschedule`).then((r) => r.data);

// Admin subscribers
export const adminListSubscribers = () => api.get("/admin/subscribers").then((r) => r.data);
export const adminDeleteSubscriber = (email) =>
  api.delete(`/admin/subscribers/${encodeURIComponent(email)}`).then((r) => r.data);
export const adminSubscriberExportUrl = () => `${API}/admin/subscribers/export`;
